import { Reducer } from 'redux';
import { produce } from 'immer';
import { KnowledgePortalsState, PORTAL_TYPES } from './types';

export const INITIAL_STATE: KnowledgePortalsState = {
  portal: {
    message: '',
    response: [],
  },
  error: null,
};

const reducer: Reducer<KnowledgePortalsState> = (
  state = INITIAL_STATE,
  action = { type: '', payload: {} },
) => {
  return produce(state, draft => {
    switch (action.type) {
      case PORTAL_TYPES.SET_DATA_KNOWLEDGE_PORTAL:
        draft.portal = action.payload;
        break;
      case PORTAL_TYPES.SET_ERROR:
        draft.error = action.payload;
        break;
      default:
    }
  });
};

export default reducer;
